import { MODEL_ALIAS_COPY } from "./copy.js";

function suggestedValues(catalog, pointer) {
    return catalog?.settings?.find((setting) => setting.pointer === pointer)?.suggestedValues ?? [];
}

/// Values the Claude Code controls derive from the draft and the catalog.
export function deriveEditorValues(controls, catalog) {
    const modelAliases = suggestedValues(catalog, "/model");
    const values = controls.restrictModels ? controls.availableModels : modelAliases;
    const withImported = controls.startingModel && !values.includes(controls.startingModel)
        ? [...values, controls.startingModel]
        : values;
    const modelOptions = [
        { value: "", label: "Claude Code Default" },
        ...withImported.map((value) => ({ value, label: MODEL_ALIAS_COPY[value]?.label ?? `${value} (imported)` })),
    ];
    const hasServer = controls.mcpServers.some((item) => item.trim());
    const mcpFilterWritten = controls.mcpMode === "block"
        || ((controls.mcpMode === "allow" || controls.mcpMode === "deny") && hasServer);
    const marketplaceRestrictionWritten = controls.marketplaceMode === "block"
        || (controls.marketplaceMode === "allow" && controls.marketplaces.some((item) => item.trim()));
    // Named models for the effect line. An administrator reads "Sonnet or Opus",
    // not a count, because the count does not say which models a session gets.
    const labels = controls.availableModels.map((value) => MODEL_ALIAS_COPY[value]?.label ?? value);
    const modelListSummary = labels.length <= 2
        ? labels.join(" or ")
        : `${labels.slice(0, -1).join(", ")}, or ${labels[labels.length - 1]}`;
    return { modelAliases, modelOptions, mcpFilterWritten, marketplaceRestrictionWritten, modelListSummary };
}

/// Selected list controls that hold no entry. Each blocks the pilot, because an
/// empty list is omitted from the document.
export function incompleteLists(controls) {
    const incomplete = [];
    const hasMcpEntries = controls.mcpServers.some((item) => item.trim());
    const hasMarketplaceEntries = controls.marketplaces.some((item) => item.trim());
    if ((controls.mcpMode === "allow" || controls.mcpMode === "deny") && !hasMcpEntries) incomplete.push("MCP server list");
    if (controls.marketplaceMode === "allow" && !hasMarketplaceEntries) incomplete.push("plugin marketplace list");
    if (controls.restrictModels && !controls.availableModels.length) incomplete.push("model allowlist");
    return incomplete;
}
